export default __webpack_public_path__ + "static/fb-cover-w-logo-efd1e6f29d86ab6979b924caab5c80f1.png";